export function sortNewestDeliveries<T extends { deliveredAt?: string | null }>(items: T[]): T[] {
    const time = (value?: string | null) => Date.parse(value || '') || 0;
    return [...items].sort((left, right) => time(right.deliveredAt) - time(left.deliveredAt));
}
